import * as React from "react";

import { Authorize as BaseAuthorize, User } from "reauthorize";

import { ADMIN_ROLES, Role } from "./model";

interface Props {
    roles?: Role[];
}

export class Authorize extends React.Component<Props> {
    public render() {
        return (
            <BaseAuthorize authorize={this.props.roles ? this.props.roles.map(role => role.name) : true}>
                {this.props.children}
            </BaseAuthorize>
        );
    }
}

export const isSystemAdmin = (user: User): boolean => {
    return user?.roles?.includes(ADMIN_ROLES.SYSTEM_ADMIN.name);
};

export const isSeniorAdministrator = (user: User): boolean => {
    return user?.roles?.includes(ADMIN_ROLES.SENIOR_ADMINISTRATOR.name);
};
